import { render, staticRenderFns } from "./AppListPager.vue?vue&type=template&id=34f47b3c&"
import script from "./AppListPager.vue?vue&type=script&lang=js&"
export * from "./AppListPager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports